import I18n from 'I18n';
import styled from 'styled-components';
import { useCallback, useState } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { H2, H5 } from 'UIComponents/elements/headings';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITextArea from 'UIComponents/input/UITextArea';
import FeedbackButtons from './FeedbackButtons';
import { isFunction } from '../../../utils/TypeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ParagraphText = styled(H2).withConfig({
  displayName: "InlineFeedbackPopover__ParagraphText",
  componentId: "sc-130rdxj-0"
})(["font-size:14px;font-weight:300;line-height:24px;"]);
const InlineFeedbackPopover = ({
  children,
  feedbackPopoverWidth = 325,
  popoverOpen,
  onSubmit,
  onCancel
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [messageFeedback, setMessageFeedback] = useState('');
  const handleMessageFeedbackChange = useCallback(({
    target: {
      value
    }
  }) => {
    setMessageFeedback(value);
  }, []);
  const handleMessageFeedbackOptionsChange = useCallback(option => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter(e => e !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  }, [selectedOptions]);
  const handleSubmit = useCallback(() => {
    if (isFunction(onSubmit)) {
      onSubmit({
        options: selectedOptions,
        message: messageFeedback
      });
    }
  }, [onSubmit, messageFeedback, selectedOptions]);
  const canSubmit = selectedOptions.length > 0 || messageFeedback.length > 0;
  return /*#__PURE__*/_jsx(UIPopover, {
    "data-test-id": "inline-feedback-popover",
    width: feedbackPopoverWidth,
    open: popoverOpen,
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.dialogHeader"
        })
      }),
      body: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ParagraphText, {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.optionSelectHeader"
          })
        }), /*#__PURE__*/_jsx(UIButtonWrapper, {
          className: "p-top-3 p-bottom-4",
          justify: "start",
          children: /*#__PURE__*/_jsx(FeedbackButtons, {
            selectedOptions: selectedOptions,
            onOptionSelect: handleMessageFeedbackOptionsChange
          })
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(UITextArea, {
            style: {
              fontSize: '12px'
            },
            placeholder: I18n.text('aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.freeformPlaceholder'),
            onBlur: handleMessageFeedbackChange
          })
        })]
      }),
      footer: /*#__PURE__*/_jsxs(UIFlex, {
        className: "width-100",
        gap: 12,
        direction: "row",
        justify: "end",
        children: [/*#__PURE__*/_jsx(UIButton, {
          onClick: onCancel,
          style: {
            width: 'fit-content',
            margin: '0'
          },
          type: "reset",
          use: "secondary",
          size: "sm",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.buttons.cancel"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "inline-feedback-popover-submit",
          onClick: handleSubmit,
          style: {
            width: 'fit-content',
            margin: '0'
          },
          type: "submit",
          use: "primary",
          size: "sm",
          disabled: !canSubmit,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.buttons.submit"
          })
        })]
      })
    },
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
export default InlineFeedbackPopover;